import loginPage from '@/pages/login'
import mainPage from '@/pages/main'
import componentAudit from '@/pages/component-audit'

import {
  roomSort,
  advertList,
  hotCity,
  recommendRoom,
  articleEdit,
  articleList,
  videoList
} from './advert'

import {
  trainingList,
  cleanerGoodsList,
  cleanerOrderList,
  cleanerTypeList,
  cleanerItemList,
  cleanerAccountList,
  housekeeperAccountEdit,
  MaterialCollarList,
  inventory,
  inventoryDetail,
  housekeepingMaterialsList,
  housekeeperBillList,
  cleaningTaskList,
  paymentDetails,
  materialUpdateDetailsList,
  dutyBillList,
  dutyOrderList,
  cleanBillList,
  additionalFee
} from './cleaner'

import {
  assoManageList,
  hotelDetail,
  roomTypeDetail,
  elongChannelList,
  elongHotelDetail,
  elongRoomTypeDetail,
  assoManageListFeiZhu,
  hotelDetailFeiZhu,
  roomTypeDetailFeiZhu,
  assoManageListTuJia,
  hotelDetailTuJia,
  roomTypeDetailTuJia
} from './ota'
import {
  updatePassword,
  roleManage,
  editRoomStatus
} from './system'

import {
  invoiceManage,
  stopSheet,
  sms,
  frontOrder,
  orderList,
  payOrder,
  createOrder,
  invoice,
  orderResource,
  refundsList,
  ownerOrderList,
  shortRent,
  consumptionList,
  OrderDetailNew,
  ImportRecordList,
  SupplementaryOrderList,
  LateCheckOutOrder,
} from './order'

import {
  orderReport,
  importRecords,
  replaceReport,
  ownerRevenue,
  pmsCheckRepor,
  miniReport,
  blueOwnerReport,
  billStatement,
  monthlySettleDetail, //月度结算详情
  manualRecord, //手工入账导入记录
  chainReport,// 门店营收报表
  chainReportDetail,
} from './report'

import {
  codeStore,
  couponCardUsedRecord,
  activationList,
  activityRewardList,
  activityList,
  activityRewardContentList,
  activityManualReward,
  activityEditView,
  activityDetailView,
  promoCodeList,
  promoCodeEdit,
  marketingExcludeRoom,
  couponCardList,
  join,
  joinArea,
  tagGroupList,
  tagList,
  tagDetailList,
  userCouponManage
} from './marketing'
import {
  companyInfo,
  develperTeam,
  hosterList,
  hosterDetail,
  starClubList
} from './blue-hoster'
import {
  roomDetail,
  editRoomElecStatus,
} from './room'
import {
  vipDetail,
  managementList
} from './vip'
import {
  smartLock,
  smartLockDetail,
  smartOpenOnline,
  dictionaryManaged,
  lockAccount
} from './smart-device'

import {
  companyList,
  companyDetail,
  promotionReport
} from './business-management'
import {
  selfServiceMachine,
  selfServiceMachineDetail
} from './smart-device'
import {
  channelList as wechatChannelList,
  tariffList,
  menuManage,
  wxQrCode,
  minprogramManage
} from './wechat'
import {
  channelAnalysis
} from './channel'

// 艺龙
import {
  elongRoomSourceOrderList,
  elongOrderDetail,
  elongTransactionRecord,
  elongPromotionReport
} from './elong';

//中心仓管理
import {
  centerManagement,
  hotelList
} from './center-management'
import ContractDeadlineCostComponent from '@/components/blue/contract-deadline-cost'

// 调整单列表/新增调整单
import {
  adjustmentList,
  addAdjustsheet,
  adjustmentDetail
} from './adjustment-sheet'

// 消息中心
import {
  noticeList
} from './message'

//店长值班管理
import {
  delegateState,
  delegateRecord
} from './delegate-management'

export default [{
    path: '',
    redirect: '/app'
  }, {
    path: '/login',
    component: loginPage
  }, {
    path: '/app',
    component: mainPage,
    children: [
      // 系统管理
      updatePassword,
      // 广告管理
      advertList,
      hotCity,
      recommendRoom,
      articleEdit,
      articleList,
      videoList,
      // ota关联管理
      assoManageList,
      hotelDetail,
      roomTypeDetail,
      // ota关联飞猪
      assoManageListFeiZhu,
      hotelDetailFeiZhu,
      roomTypeDetailFeiZhu,
      // ota关联途家
      assoManageListTuJia,
      hotelDetailTuJia,
      roomTypeDetailTuJia,
      elongChannelList,
      elongHotelDetail,
      elongRoomTypeDetail,
      //丽家会培训
      trainingList,
      cleanerGoodsList,
      cleanerOrderList,
      cleanerTypeList,
      cleanerItemList,
      cleanerAccountList,
      housekeeperAccountEdit, //修改管家账号
      MaterialCollarList, //物资领用
      housekeepingMaterialsList, //管家物资出入库表
      housekeeperBillList, //管家即时账单列表
      cleaningTaskList,
      paymentDetails, //管家即时账单详情
      materialUpdateDetailsList, //管家库存明细表
      dutyBillList, //值班账单列表
      dutyOrderList, //值班单管理
      cleanBillList, // 清洁账单列表
      additionalFee, // 清洁单附属费用设置
      // 订单
      stopSheet,
      sms,
      frontOrder,
      createOrder,
      orderList,
      payOrder,
      invoice,
      orderResource,
      ownerOrderList,
      shortRent,
      smartLock,
      smartLockDetail,
      lockAccount,
      smartOpenOnline,
      dictionaryManaged, //字典管理
      OrderDetailNew,
      ImportRecordList,
      LateCheckOutOrder,
      SupplementaryOrderList, //订单记录
      // 报表
      orderReport,
      importRecords,
      replaceReport,
      // 营销管理
      codeStore,
      couponCardUsedRecord,
      activationList,
      activityRewardList,
      activityList,
      activityRewardContentList,
      activityManualReward,
      activityEditView,
      activityDetailView,
      promoCodeList,
      promoCodeEdit,
      marketingExcludeRoom,
      couponCardList,
      join,
      joinArea,
      tagGroupList,
      tagList,
      tagDetailList,
      userCouponManage,
      ownerRevenue,
      pmsCheckRepor,
      miniReport,
      blueOwnerReport,//蓝主人业主报表
      billStatement, // 结算账单报表
      monthlySettleDetail,//月度结算详情
      manualRecord,//手工入账导入记录
      // 蓝主任
      develperTeam,
      hosterList,
      hosterDetail,
      companyInfo,
      // 房间信息
      roomDetail,
      editRoomElecStatus,
      refundsList,
      //蓝主人-星创俱乐部
      starClubList,
      // 会员管理
      vipDetail,
      managementList,
      // 企业管理
      companyList,
      companyDetail,
      promotionReport,
      //智能硬件管理
      selfServiceMachine,
      selfServiceMachineDetail,
      // 微信
      wechatChannelList,
      tariffList,
      managementList,
      menuManage,
      wxQrCode,
      minprogramManage,

      // 渠道管理分析
      channelAnalysis,
      managementList,
      //入账单列表
      consumptionList,
      //发票管理
      invoiceManage,
      roomSort,
      //权限系统
      roleManage,
      // 修改远期房态
      editRoomStatus,
      //中心仓管理
      centerManagement,
      // 门店列表
      hotelList,
      //调整单列表
      adjustmentList,
      addAdjustsheet, //新增调整单
      adjustmentDetail, //调整单详情
      inventory,
      inventoryDetail,
      // 艺龙订单,
      elongRoomSourceOrderList,
      elongOrderDetail,
      elongTransactionRecord,
      elongPromotionReport,
      // 消息中心
      noticeList, // 公告通知列表
      
      //店长值班
      delegateState,
      delegateRecord,

      // 门店利润表
      chainReport,
      chainReportDetail
    ]
  }, {
    path: '/components',
    component: componentAudit,
    children: [{
      path: 'ContractDeadlineCost',
      component: ContractDeadlineCostComponent
    }]
  }

]



// WEBPACK FOOTER //
// ./src/router/index.js